<script>
import {mapActions} from 'vuex'
import suburbVue from '../suburb/suburb.vue'

export default {
  data() {
    return {
      suburbList:'',
      agencyList:'',
      propertyTypeList:'',
      uconnectTypeList:['Public','U-Connect'],
      searchValues: {
        search:'',
        suburb:'',
        agency:'',
        propertyType:'',
        uconnectType:''
      },
    }
  },
  components: {},
  props: {
    adminRole: String
  },
  methods: {
    ...mapActions(['getSearchDropdown']),
    search(){
      this.$emit('searchTrigger',this.searchValues)
    },
    getSearchDropdownValues(){
      let pat={
        }
      this.getSearchDropdown({pat:pat,callback:this.callback})
    },
    callback(resp,status){
      switch (status) {
            case 'getSearchDropdown':
                if(resp.code==0){
                    this.suburbList=resp.data.suburbs
                    this.agencyList=resp.data.agencies
                    this.propertyTypeList=resp.data.propertyTypes
                }else{
                    Utils.alert('',resp.message,'error')
                }
            break;
        }
    }
  },
  mounted() {
    this.getSearchDropdownValues()
  }
}
</script>

<template>
  <el-row>
    <el-row >

      <el-col :span="20">
        <el-row>
          <!--property id, adddess, -->
          <el-col :span="5" style="display: flex; justify-content: center; ">
            <div class="textFieldsStyle">
              <div class="textFieldsStyle">Search</div>
              <el-input placeholder="ID or Address" v-model="searchValues.search" class="textFieldsStyle">
              </el-input>
            </div>
          </el-col>

          <!--agency-->
          <el-col :span="5" v-if="adminRole ==1" style="display: flex; justify-content: center; ">

            <div class="textFieldsStyle">
              <div class="textFieldsStyle">Agency</div>
              <el-select clearable v-model="searchValues.agency" filterable placeholder="Select">
                <el-option v-for="item in this.agencyList" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>

          </el-col>

          <!--suburb-->
          <el-col :span="5" style="display: flex; justify-content: center; ">

            <div class="textFieldsStyle">
              <div class="textFieldsStyle">Suburb</div>
              <el-select clearable v-model="searchValues.suburb" filterable placeholder="Select">
                <el-option v-for="item in this.suburbList" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>

          </el-col>

          <!--property type-->
          <el-col :span="4" style="display: flex; justify-content: center; ">

            <div class="textFieldsStyle">
              <div class="textFieldsStyle">Property Type</div>
              <el-select clearable v-model="searchValues.propertyType" filterable placeholder="Select">
                <el-option v-for="item in this.propertyTypeList" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </el-col>

          <!--property type-->
<!--          <el-col :span="5" style="display: flex; justify-content: center; ">-->

<!--            <div class="textFieldsStyle">-->
<!--              <div class="textFieldsStyle">U-Connect</div>-->
<!--              <el-select clearable v-model="searchValues.uconnectType" filterable placeholder="Select" class="textFieldsStyle">-->
<!--                <el-option v-for="item in this.uconnectTypeList" :key="item" :label="item" :value="item">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </div>-->
<!--          </el-col>-->
        </el-row>
      </el-col>
      <el-col :span="4" style="display: flex; justify-content: flex-end; ">
        <el-row>
          <el-col :span="3" style="display: flex; justify-content: center; ">
            <el-button class="searchBtn" @click="search">Search</el-button>
          </el-col>
        </el-row>
      </el-col>


    </el-row>
    <el-row>





      <!--listing date range-->
      <!-- <el-col :span="4" style="display: flex; justify-content: center; ">
      </el-col> -->

    </el-row>
  </el-row>
</template>

<style scoped>
.searchBtn {
  color: #ffffff;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 3px solid #003333;
  background-color: #003333;
  align-self: start;
  font: 600 20px DINosaur-a, sans-serif;
  margin-top:10px
}
.textFieldsStyle{
  font-weight: 600;
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/listing/listingsSearchBar.vue